import { VehicleRowGroup } from 'src/pages/ConvenienceDispatches/adapter';

import { WorkTarget } from './types';

export type RawShiftTime = { startAt: string; endAt: string; shiftId: number | null };

/**
 * 勤務ごとのドロップ先を作る。
 *
 * Why raw delivery を見るか: VehicleInfoExtra.shiftStart / shiftEnd は HH:mm で
 * 日付が落ちており、覆う日カラムを出せない。しかも truckId 代表なので、1 台に
 * 複数の勤務が乗ると 2 件目以降が 1 件目の値になる（adapter.ts のコメント）。
 */
export function buildWorkTargets(
  groups: VehicleRowGroup[],
  deliveryById: ReadonlyMap<number, RawShiftTime>,
): WorkTarget[] {
  const targets: WorkTarget[] = [];

  for (const group of groups) {
    const shiftTruckId = group.shiftTruckId;
    if (shiftTruckId == null) continue;
    const raw = deliveryById.get(shiftTruckId);
    if (!raw) continue;
    const lastRow = group.rows[group.rows.length - 1];
    if (!lastRow) continue;

    targets.push({
      shiftTruckId,
      shiftId: raw.shiftId,
      startAt: raw.startAt,
      endAt: raw.endAt,
      targetRowId: lastRow.rowId,
    });
  }

  return targets;
}
